<template>
  <div class="code-rain-bg" aria-hidden="true">
    <div
      v-for="(col, i) in columns"
      :key="i"
      class="rain-column"
      :style="col.style"
    >{{ col.text }}</div>
  </div>
</template>

<script setup>
// 28 columns of 55 random binary chars each.
// Negative animation-delay puts every column mid-fall on load — no "big bang" start.
const CHARS = '01'
const COL_COUNT = 28
const LINES = 55

function rand(min, max) {
  return min + Math.random() * (max - min)
}

const columns = Array.from({ length: COL_COUNT }, (_, i) => {
  const text = Array.from({ length: LINES }, () =>
    CHARS[Math.floor(Math.random() * CHARS.length)]
  ).join('\n')

  const spread = 100 / COL_COUNT

  return {
    text,
    style: {
      left:                `${(i * spread + rand(0, spread * 0.6)).toFixed(1)}%`,
      fontSize:            `${Math.round(rand(10, 13))}px`,
      opacity:             rand(0.10, 0.22).toFixed(3),
      animationDuration:   `${Math.round(rand(22, 48))}s`,
      animationDelay:      `-${Math.round(rand(0, 40))}s`,
    },
  }
})
</script>

<style lang="scss">
.code-rain-bg {
  position: fixed;
  inset: 0;
  z-index: -1;
  pointer-events: none;
  overflow: hidden;
  user-select: none;

  .rain-column {
    position: absolute;
    top: 0;
    font-family: 'Courier New', 'Consolas', monospace;
    line-height: 1.6;
    color: var(--accent-color);   /* #00c8ff — brand cyan */
    white-space: pre;
    will-change: transform;
    animation: rainFall linear infinite;
    transform: translateY(-100%);
  }
}

@keyframes rainFall {
  from { transform: translateY(-100%); }
  to   { transform: translateY(calc(100vh + 100%)); }
}
</style>
